import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProfileModulesGuard } from '@app/auth/profile-modules.guard';
import { SprintComponent } from './sprint/sprint.component';
import { TicketLogHistoryComponent } from './sprint/ticket-log-history/ticket-log-history.component';
import { EditTicketComponent } from './ticket/edit-ticket/edit-ticket.component';
import { RecentlyViewedTicketsComponent } from './ticket/recently-viewed-tickets/recently-viewed-tickets.component';
import { TcTicketListComponent } from './ticket/tc-ticket-list/tc-ticket-list.component';
import { TcTicketListBetaComponent } from './ticket/tc-ticket-list-beta/tc-ticket-list-beta.component';
import { NewTicketComponent } from './ticket/ticket-create/new-ticket.component';
import { UpdateAssistantComponent } from './ticket/update-assistant/update-assistant.component';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'sprint',
  },
  {
    path: 'sprint',
    component: SprintComponent,
    data: {
      title: 'Sprint',
      requiredModules: ['Sprint'],
      beta: true,
    },
    canActivate: [ProfileModulesGuard],
  },
  // {
  //   path: 'beta-sprint',
  //   component: SprintComponent,
  //   data: {
  //     title: 'Sprint (Beta)',
  //     requiredModules: ['Sprint'],
  //     beta: true,
  //   },
  //   canActivate: [ProfileModulesGuard],
  // },
  {
    path: 'vistos-recentemente',
    component: RecentlyViewedTicketsComponent,
    data: {
      title: 'Chamados vistos recentemente',
      requiredModules: ['RecentTickets'],
    },
    canActivate: [ProfileModulesGuard],
  },
  {
    path: 'atualizacoes',
    component: UpdateAssistantComponent,
    data: {
      title: 'Assistente de atualização',
      requiredModules: ['UpdateAssistant'],
    },
    canActivate: [ProfileModulesGuard],
  },
  {
    path: 'novo',
    component: NewTicketComponent,
    data: {
      title: 'Novo Chamado',
      requiredModules: ['Tickets'],
      checkCanWrite: true,
    },
    canActivate: [ProfileModulesGuard],
  },
  {
    path: 'apontamentos/historico',
    component: TicketLogHistoryComponent,
    data: {
      title: 'Histórico de apontamentos',
      requiredModules: ['AppointmentHistory'],
    },
    canActivate: [ProfileModulesGuard],
  },
  {
    path: 'editar/:id',
    component: EditTicketComponent,
    data: {
      title: 'Editar chamado',
      requiredModules: ['Tickets'],
      checkCanWrite: true,
    },
    canActivate: [ProfileModulesGuard],
  },
  {
    path: 'lista',
    component: TcTicketListComponent,
    data: {
      title: 'Listagem de chamados',
      requiredModules: ['Tickets'],
    },
    canActivate: [ProfileModulesGuard],
  },
  {
    path: 'lista-beta',
    component: TcTicketListBetaComponent,
    data: {
      title: 'Listagem de chamados Beta',
      requiredModules: ['Tickets'],
    },
    canActivate: [ProfileModulesGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TicketCenterRouting {}
